import { Component } from '@angular/core';
import { AppService } from './shared/services/app.service';
import { Router, NavigationStart } from '@angular/router';
import 'rxjs/add/operator/filter';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  bgClass: string;
  showLoader: boolean = true;
  showMainNav: boolean = true;

  constructor(
    private _appService: AppService ,
    private _router: Router
  ) {

    this._router.events
      .filter(event => event instanceof NavigationStart)
      .subscribe((event: NavigationStart) => {
        this.showMainNav = true;
        this.bgClass = '';
      })

    this._appService.showMainNav$.subscribe(
      showMainNav => this.showMainNav = showMainNav
    );

    this._appService.bgClass$.subscribe(
      colorClass => this.bgClass = colorClass
    );
    this._appService.showLoader$.subscribe(
      b => {
        //console.log("show loader "+b)
        this.showLoader = b
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts